import * as React from "react";
import {
    Button,
    Typography,
} from "@material-ui/core";
import Box from "@material-ui/core/Box";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import api from "../../../store/api";
import _ from "lodash";


const StartTripFooter = ({
    transferCount,
    onClearPress,
    startTripClick,
}: any) => {
    const [canStartAtrip, setCanStartAtrip] = React.useState(0);
    const [tripErrorMessage, setTripErrorMessage] = React.useState(0);

    React.useEffect(() => {
        api.canStartAtrip("").then((res) => {
            setCanStartAtrip(res?.model?.result ? (res?.model?.result ? 2 : 1) : 1);
            setTripErrorMessage(
                res?.model?.message
                    ? res?.model?.message
                    : "This vehicle is currently in a trip with other Driver."
            );
        });
    }, []);

    return (
        <div style={{ position: "fixed", width: "100%", bottom: 0 }}>
            <Box
                margin={0}
                height={59}
                style={{
                    background: "#F4B827",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
            >
                <div style={{ display: "flex", alignItems: "center" }}>
                    <Typography
                        style={{
                            marginLeft: 30,
                            color: "#03090E",
                            fontWeight: 400,
                            fontSize: 18,
                        }}
                        variant="body1"
                        component="div"
                    >
                        {transferCount} transfers selected
                    </Typography>
                    <Button onClick={onClearPress}>
                        <Typography
                            style={{
                                marginLeft: 30,
                                color: "#03090E",
                                fontWeight: 700,
                                fontSize: 18,
                            }}
                            variant="body1"
                            component="div"
                        >
                            Clear Selections
                        </Typography>
                    </Button>
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                    {canStartAtrip == 2 ? (
                        <Button onClick={startTripClick}>
                            <Typography
                                style={{
                                    marginLeft: 30,
                                    color: "#03090E",
                                    fontWeight: 700,
                                    fontSize: 24,
                                }}
                                variant="body1"
                                component="div"
                            >
                                Start Trip
                            </Typography>
                            <ArrowForwardIosIcon
                                style={{ fontSize: 20, color: "#03090E", marginLeft: 20 }}
                            />
                        </Button>
                    ) : canStartAtrip == 1 ? (
                        <Typography
                            style={{
                                marginRight: 20,
                                color: "#03090E",
                                fontWeight: 700,
                                fontSize: 18,
                            }}
                            variant="body1"
                            component="div"
                        >
                            {tripErrorMessage}
                        </Typography>
                    ) : null}
                </div>
            </Box>
        </div>
    );
};

export default StartTripFooter;